import React, { useState } from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pay.hotmart.com/O103704589E';
const CHECKOUT_PRO = 'https://pay.hotmart.com/Y104782550L';
function playPurchaseSound() {
  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = 'sine';
    osc1.frequency.setValueAtTime(1200, ctx.currentTime);
    osc1.frequency.exponentialRampToValueAtTime(1800, ctx.currentTime + 0.08);
    gain1.gain.setValueAtTime(0.3, ctx.currentTime);
    gain1.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.start(ctx.currentTime);
    osc1.stop(ctx.currentTime + 0.3);
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = 'sine';
    osc2.frequency.setValueAtTime(1600, ctx.currentTime + 0.1);
    osc2.frequency.exponentialRampToValueAtTime(2200, ctx.currentTime + 0.18);
    gain2.gain.setValueAtTime(0, ctx.currentTime);
    gain2.gain.setValueAtTime(0.25, ctx.currentTime + 0.1);
    gain2.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4);
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.start(ctx.currentTime + 0.1);
    osc2.stop(ctx.currentTime + 0.4);
  } catch (e) {}
}
function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-2.5 text-left" data-id="element-409">
      <div className="bg-[#d4a017]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-410">
        <CheckIcon className="w-3.5 h-3.5 text-[#f0c040]" strokeWidth={3} data-id="element-411" />
      </div>
      <span className="text-gray-300 text-sm leading-snug" data-id="element-412">{children}</span>
    </div>;
}
export function SelectablePricingSection() {
  const [selected, setSelected] = useState<'base' | 'premium'>('premium');
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [ref3, vis3] = useReveal();
  return <section id="selectable-pricing" className="bg-[#0f0f1a] text-white py-14 md:py-20 px-4 border-t border-white/5" style={{
    scrollMarginTop: '20px'
  }} data-id="element-413">
      <div className="container mx-auto max-w-2xl" data-id="element-414">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-6 md:mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-415">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3 text-white leading-tight" data-id="element-416">
            Elegí tu formación Reiki
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-417">
            Ambas opciones incluyen acceso inmediato, formación paso a paso y
            materiales complementarios para comenzar tu camino en Reiki.
          </p>
        </div>

        {/* Cards Container */}
        <div id="selectable-cards" ref={ref2} style={{
        scrollMarginTop: '10px'
      }} className={`reveal flex flex-col md:flex-row gap-3 md:gap-5 items-stretch mb-6 ${vis2 ? 'is-visible' : ''}`} data-id="element-418">
          {/* CARD 1: Base */}
          <div onClick={() => setSelected('base')} className={`relative flex-1 cursor-pointer rounded-xl p-3.5 sm:p-5 border-2 transition-all duration-300 flex flex-col ${selected === 'base' ? 'border-green-500/50 bg-[#1e1e30] shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-white/10 bg-[#1a1a2e] opacity-80 hover:opacity-100 hover:border-white/20'}`} data-id="element-419">
            <div className="flex items-start gap-2 mb-2" data-id="element-420">
              <div className={`w-4.5 h-4.5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${selected === 'base' ? 'border-green-500' : 'border-gray-500'}`} style={{
              width: '18px',
              height: '18px'
            }} data-id="element-421">
                {selected === 'base' && <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-422" />}
              </div>
              <div data-id="element-423">
                <h3 className="text-base sm:text-lg font-serif font-bold text-white mb-0.5 leading-tight" data-id="element-424">
                  🌿 Curso Integral Reiki
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed" data-id="element-425">
                  Ideal si querés comenzar desde cero con una formación
                  completa, clara y práctica.
                </p>
              </div>
            </div>

            <div className="my-3 pl-7" data-id="element-426">
              <p className="text-gray-500 text-[11px] line-through mb-0.5" data-id="element-427">
                $30 USD
              </p>
              <p className="text-2xl sm:text-3xl font-extrabold text-white leading-none" data-id="element-428">
                $10 USD
              </p>
            </div>

            <div className="space-y-1.5 flex-grow pl-7" data-id="element-429">
              <p className="text-gray-400 text-[10px] font-bold uppercase tracking-wider mb-1" data-id="element-430">
                Incluye:
              </p>
              <FeatureItem data-id="element-431">6 tomos completos de Reiki</FeatureItem>
              <FeatureItem data-id="element-432">Libro de trabajo de Reiki</FeatureItem>
              <FeatureItem data-id="element-433">Guía de los 7 chakras</FeatureItem>
              <FeatureItem data-id="element-434">Guía práctica de meditación</FeatureItem>
            </div>
          </div>

          {/* CARD 2: Premium */}
          <div onClick={() => setSelected('premium')} className={`relative flex-1 cursor-pointer rounded-xl p-3.5 sm:p-5 border-2 transition-all duration-300 flex flex-col ${selected === 'premium' ? 'border-[#d4a017]/60 bg-gradient-to-b from-[#1e1e30] to-[#252538] shadow-[0_0_40px_rgba(212,160,23,0.2)] md:scale-[1.03] z-10' : 'border-[#d4a017]/30 bg-[#1e1e30] opacity-90 hover:opacity-100 hover:border-[#d4a017]/50'}`} data-id="element-435">
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#d4a017] to-[#b8860b] text-[#0f0f1a] text-[9px] font-bold px-3 py-0.5 rounded-full shadow-lg z-20 whitespace-nowrap" data-id="element-436">
              ⭐ Más elegida
            </div>

            <div className="flex items-start gap-2 mb-2 mt-1" data-id="element-437">
              <div className={`rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${selected === 'premium' ? 'border-[#f0c040]' : 'border-gray-500'}`} style={{
              width: '18px',
              height: '18px'
            }} data-id="element-438">
                {selected === 'premium' && <div className="w-2 h-2 rounded-full bg-[#f0c040]" data-id="element-439" />}
              </div>
              <div data-id="element-440">
                <h3 className="text-base sm:text-lg font-serif font-bold text-white mb-0.5 leading-tight" data-id="element-441">
                  ✨ Formación Integral Reiki Premium
                </h3>
                <p className="text-gray-300 text-xs leading-relaxed" data-id="element-442">
                  La opción más completa para quienes quieren profundizar,
                  transformarse y sumar herramientas extra.
                </p>
              </div>
            </div>

            <div className="my-3 pl-7" data-id="element-443">
              <p className="text-gray-500 text-[11px] line-through mb-0.5" data-id="element-444">
                $50 USD
              </p>
              <div className="flex items-center gap-2 mb-0.5" data-id="element-445">
                <p className="text-2xl sm:text-3xl font-extrabold text-white leading-none" data-id="element-446">
                  $18 USD
                </p>
                <span className="bg-green-500/20 text-green-400 text-[9px] font-bold px-1.5 py-0.5 rounded border border-green-500/30" data-id="element-447">
                  Ahorrás $32 USD
                </span>
              </div>
            </div>

            <div className="space-y-1.5 flex-grow pl-7" data-id="element-448">
              <p className="text-[#f0c040] text-[10px] font-bold uppercase tracking-wider mb-1" data-id="element-449">
                Incluye todo lo anterior +
              </p>
              <FeatureItem data-id="element-450">Todo lo del Curso Integral Reiki</FeatureItem>
              <FeatureItem data-id="element-451">Cómo vivir del Reiki</FeatureItem>
              <FeatureItem data-id="element-452">Curso completo de Reflexología</FeatureItem>
              <FeatureItem data-id="element-453">Curso completo de Aromaterapia</FeatureItem>
            </div>
          </div>
        </div>

        {/* Dynamic CTA Button */}
        <div ref={ref3} className={`reveal max-w-md mx-auto text-center ${vis3 ? 'is-visible' : ''}`} data-id="element-454">
          <a href={selected === 'premium' ? CHECKOUT_PRO : CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" onClick={playPurchaseSound} className={`w-full block py-4 md:py-5 rounded-xl text-white font-bold text-base sm:text-lg md:text-xl tracking-widest uppercase text-center transition-all duration-300 ${selected === 'premium' ? 'bg-[#c82333] hover:bg-[#bd2130] border border-red-500/50 shadow-[0_0_30px_rgba(200,35,51,0.4)] hover:shadow-[0_0_40px_rgba(200,35,51,0.6)] hover:-translate-y-1' : 'bg-green-600 hover:bg-green-700 border border-green-500/50 shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] hover:-translate-y-1'}`} style={{
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.1em'
        }} data-id="element-455">
            {selected === 'premium' ? '✨ Sí, quiero la formación premium' : '💚 Sí, quiero comenzar con Reiki'}
          </a>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-6 text-gray-400 text-xs sm:text-sm font-medium" data-id="element-456">
            <span className="flex items-center gap-1.5" data-id="element-457">
              <span className="text-base" data-id="element-458">⚡</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-459">
              <span className="text-base" data-id="element-460">💻</span> 100% online
            </span>
            <span className="flex items-center gap-1.5" data-id="element-461">
              <span className="text-base" data-id="element-462">🔒</span> Pago seguro con Mercado Pago
            </span>
            <span className="flex items-center gap-1.5" data-id="element-463">
              <span className="text-base" data-id="element-464">🌱</span> Sin experiencia previa
              necesaria
            </span>
          </div>
        </div>

        {/* Why Premium Block */}
        <div className="mt-8 max-w-2xl mx-auto bg-[#1e1e30] rounded-xl border border-white/10 p-4 md:p-5 shadow-lg" data-id="element-465">
          <h3 className="text-base md:text-lg font-serif font-bold text-white mb-3 text-center" data-id="element-466">
            ¿Por qué la mayoría elige la formación premium?
          </h3>
          <div className="space-y-2.5 mb-4" data-id="element-467">
            <div className="flex items-start gap-2" data-id="element-468">
              <div className="bg-[#d4a017]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-469">
                <CheckIcon className="w-3.5 h-3.5 text-[#f0c040]" strokeWidth={3} data-id="element-470" />
              </div>
              <p className="text-gray-300 text-sm md:text-base" data-id="element-471">
                Porque incluye todo el curso completo de Reiki
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-472">
              <div className="bg-[#d4a017]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-473">
                <CheckIcon className="w-3.5 h-3.5 text-[#f0c040]" strokeWidth={3} data-id="element-474" />
              </div>
              <p className="text-gray-300 text-sm md:text-base" data-id="element-475">
                Porque suma herramientas extra para aplicar, profundizar y
                expandir conocimientos
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-476">
              <div className="bg-[#d4a017]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-477">
                <CheckIcon className="w-3.5 h-3.5 text-[#f0c040]" strokeWidth={3} data-id="element-478" />
              </div>
              <p className="text-gray-300 text-sm md:text-base" data-id="element-479">
                Porque por una diferencia pequeña acceden a mucho más contenido
                y valor
              </p>
            </div>
          </div>
          <p className="text-center text-gray-400 text-xs italic border-t border-white/10 pt-4" data-id="element-480">
            La opción premium es ideal para quienes quieren vivir una
            experiencia más completa.
          </p>
        </div>
      </div>
    </section>;
}